import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { history, store } from './helpers';
import registerServiceWorker from './registerServiceWorker';
import App from './components/App/App';
import './style/index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { integrateUsingKeycloakToken } from './helpers/keycloak';

integrateUsingKeycloakToken();

render(
    <Provider store={store}>
        <Router history={history}>
            <App />
        </Router>
    </Provider>,
    document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js